export default __webpack_public_path__ + "static/media/personal-loan-chart-2.7cc9dddf.svg";